var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modules-settings-tenants-list" }, [
    _c("div", { staticClass: "nav-section" }, [
      _c(
        "a",
        {
          staticClass: "nav-back",
          on: {
            click: function ($event) {
              return _vm.navToTenancyUserTab()
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("action.backToTenancyUserTab")))]
      ),
    ]),
    _vm._v(" "),
    _c("label", { staticClass: "title" }, [
      _vm._v(_vm._s(_vm.$t("settings.user.tenant.all"))),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticStyle: { display: "inline", "vertical-align": "middle" } },
      [
        _c("span", [
          _vm._v(
            _vm._s(_vm.$t("total")) +
              ": " +
              _vm._s(_vm.orderedItems.length) +
              " / " +
              _vm._s(_vm.recordCounts)
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "tender-table" },
      [
        [
          _c("table", [
            _c(
              "thead",
              _vm._l(_vm.itemHeaders, function (header, index) {
                return _c("th", { key: index, class: header.class }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t(header.name)) +
                      "\n          "
                  ),
                ])
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "tbody",
              [
                _c("tr", [
                  _c("td", { staticClass: "tenant-id" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.itemHeaders[0].filter,
                          expression: "itemHeaders[0].filter",
                        },
                      ],
                      staticClass: "setting-users-filter-search",
                      attrs: { type: "text" },
                      domProps: { value: _vm.itemHeaders[0].filter },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.itemHeaders[0],
                            "filter",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "tenant-name" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.itemHeaders[1].filter,
                          expression: "itemHeaders[1].filter",
                        },
                      ],
                      staticClass: "setting-users-filter-search",
                      attrs: { type: "text" },
                      domProps: { value: _vm.itemHeaders[1].filter },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.itemHeaders[1],
                            "filter",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticClass:
                        "settings-filter align-center tenant-special",
                    },
                    [
                      _c("HKLSelect", {
                        staticClass: "align-center",
                        attrs: {
                          value: _vm.itemHeaders[2].filter,
                          "settings-filter-row": "",
                          options: _vm.ynHklOptions,
                          showSearch: false,
                          placeholder: "",
                        },
                        on: {
                          change: function (val) {
                            _vm.itemHeaders[2].filter = val
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _vm._l(_vm.orderedItems, function (item) {
                  return _c("tr", { key: item.id }, [
                    _c("td", { staticClass: "tenant-id" }, [
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.navToDetail(item.id)
                            },
                          },
                        },
                        [_vm._v(_vm._s(item.id))]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "tenant-name" }, [
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.navToDetail(item.id)
                            },
                          },
                        },
                        [_vm._v(_vm._s(item.name))]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "tenant-special" }, [
                      _c("a", [
                        _vm._v(_vm._s(_vm._f("customYNLabel")(item.special))),
                      ]),
                    ]),
                  ])
                }),
              ],
              2
            ),
          ]),
        ],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }